import { Stack, Typography, Box, FormControl, TextField } from '@mui/material'
import React, { useContext } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { StatusCheckPredicateConfiguration } from 'components/status-checks/form/status-check/StatusCheckPredicateConfiguration'
import { TestStatusCheckSuccessEvaluation } from 'components/status-checks/form/status-check/TestStatusCheckSuccessEvaluation'
import {
  StatusCheckFormValues,
  buildEvaluationConfigurationFromFormValues
} from 'components/status-checks/status-checks-form-utils'
import { StatusCheckDetailsContext } from 'context/status-checks/StatusCheckDetailsContext'
import { useTranslation } from 'hooks/use-translation'

export const StatusCheckSuccessEvaluation: React.FC = () => {
  const { trans } = useTranslation()
  const {
    endpointResponse,
    isTestSuccessEvaluationDisabled,
    setIsStatusCheckEvaluationValidated,
    shouldDisplayPredicateConfiguration
  } = useContext(StatusCheckDetailsContext)

  const { control, getValues, setValue } =
    useFormContext<StatusCheckFormValues>()

  return (
    <Stack spacing={3}>
      <Stack>
        <Typography variant="h6">
          {trans(
            'forms.save_status_check.connect_monitor.success_evaluation.header.label'
          )}
        </Typography>
        <Typography>
          {trans(
            'forms.save_status_check.connect_monitor.success_evaluation.subheader.label'
          )}
        </Typography>
      </Stack>
      <Box>
        <Stack ml={2} spacing={2}>
          <FormControl sx={{ width: '50%' }}>
            <Controller
              control={control}
              name="healthyStatusCode"
              render={({ field }) => (
                <TextField
                  {...field}
                  disabled={Boolean(!endpointResponse)}
                  helperText={trans(
                    'forms.save_status_check.connect_monitor.success_evaluation.healthy_status_code.text_field.helper_text'
                  )}
                  label={trans(
                    'forms.save_status_check.connect_monitor.success_evaluation.healthy_status_code.text_field.label'
                  )}
                  variant="outlined"
                  onChange={(e) => {
                    const formValues = {
                      ...getValues(),
                      healthyStatusCode: e.target.value
                    }

                    setValue(
                      'evaluationConfiguration',
                      buildEvaluationConfigurationFromFormValues(formValues)
                    )

                    field.onChange(e)
                  }}
                />
              )}
            />
          </FormControl>
          <FormControl sx={{ width: '50%' }}>
            <Controller
              control={control}
              name="requestTimeout"
              render={({ field }) => (
                <TextField
                  {...field}
                  disabled={Boolean(!endpointResponse)}
                  helperText={trans(
                    'forms.save_status_check.connect_monitor.success_evaluation.request_timeout.text_field.helper_text'
                  )}
                  label={trans(
                    'forms.save_status_check.connect_monitor.success_evaluation.request_timeout.text_field.label'
                  )}
                  type="number"
                  variant="outlined"
                  onChange={(e) => {
                    // Necessary because this value is converted to a string at the DOM level
                    const newRequestTimout = parseInt(e.target.value)

                    const formValues = {
                      ...getValues(),
                      requestTimeout: newRequestTimout
                    }

                    setValue(
                      'evaluationConfiguration',
                      buildEvaluationConfigurationFromFormValues(formValues)
                    )

                    field.onChange(newRequestTimout)
                  }}
                />
              )}
            />
          </FormControl>
          {shouldDisplayPredicateConfiguration && (
            <StatusCheckPredicateConfiguration />
          )}
          <TestStatusCheckSuccessEvaluation
            disabled={isTestSuccessEvaluationDisabled}
            endpointResponse={endpointResponse}
            onChanged={setIsStatusCheckEvaluationValidated}
          />
        </Stack>
      </Box>
    </Stack>
  )
}
